import Editor from "../../../../public/vendor/ckeditor5/src/ckeditor";

$(document).ready(function () {
    $(document).on('nc.sidePanel.shown', function (e, result) {
        createEditors();
    });

    function createEditors() {
        const editors = ['#foot_note'];

        editors.forEach(selector => {
            const element = document.querySelector(selector);
            if (!element) { return; }
            Editor
                .create(element)
                .then(editor => {
                    return editor;
                });
        });
    }
});
